import { render, staticRenderFns } from "./imgP.vue?vue&type=template&id=d2bb609e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2bb609e')) {
      api.createRecord('d2bb609e', component.options)
    } else {
      api.reload('d2bb609e', component.options)
    }
    module.hot.accept("./imgP.vue?vue&type=template&id=d2bb609e", function () {
      api.rerender('d2bb609e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgP.vue"
export default component.exports